import generatedPlaybookCatalog from '../generated/playbook-catalog.generated.json';

export interface PlaybookFieldOption {
  label: string;
  value: string;
  icon?: string;
}

export interface PlaybookField {
  id: string;
  label: string;
  type: 'text' | 'select' | 'multi-select' | 'context';
  placeholder?: string;
  required?: boolean;
  allowCustom?: boolean;
  options?: PlaybookFieldOption[];
  /** For type: 'context' — the entity type to select */
  contextType?: 'business' | 'proposal';
  /** For type: 'context' — another field ID this depends on (e.g. proposal depends on business) */
  dependsOn?: string;
  /** For type: 'context' — fallback text when no entity is selected (used on content site) */
  defaultValue?: string;
  /** For type: 'context' — label for the "new" option */
  newLabel?: string;
}

export interface PlaybookPromptPart {
  type: 'text' | 'field';
  value: string;
}

export interface PlaybookEntry {
  slug: string;
  title: string;
  icon: string;
  agent: string;
  promptTemplate: string;
  promptParts: PlaybookPromptPart[];
  recommendedModel?: string | null;
  recommendedToolGroups?: string[];
  systemPromptOverride: string | null;
  fields: PlaybookField[];
  description: string;
}

export const playbookCatalog: PlaybookEntry[] = generatedPlaybookCatalog as PlaybookEntry[];

const playbooksBySlug = new Map<string, PlaybookEntry>();
playbookCatalog.forEach((playbook) => {
  playbooksBySlug.set(playbook.slug, playbook);
});

export function getPlaybookBySlug(slug: string): PlaybookEntry | undefined {
  return playbooksBySlug.get(slug);
}

export function getPlaybooksForAgent(agentSlug: string): PlaybookEntry[] {
  return playbookCatalog.filter((playbook) => playbook.agent === agentSlug);
}

export function resolvePlaybookPrompt(playbook: PlaybookEntry, fieldValues: Record<string, string>): string {
  return playbook.promptTemplate.replace(/\{\{(\w+)\}\}/g, (match, fieldId) => {
    return fieldValues[fieldId] || match;
  });
}
